import React from 'react';
import { Route, Switch } from 'react-router-dom';

import LandingPage from './LandingPage';
import RedirectToDownload from './RedirectToDownload';
import paths from './paths';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import Gallery from './Gallery';

const { terms, privacyPolicy, download, gallery } = paths;

function App() {
  return (
    <Switch>
      <Route exact path={download} component={RedirectToDownload} />
      {/* <Route exact path={terms} component={TermsAndConditions} /> */}
      <Route exact path={privacyPolicy} component={PrivacyPolicy} />
      <Route exact path={gallery} component={Gallery} />
      <Route render={() => <LandingPage />} />
    </Switch>
  );
}

export default App;
